export const styles = theme => ({
    container: {
        flexGrow: 1,
        display: "block",
        margin: 0,
    },
    title: {
        "& h3": {
            margin: "1.5rem 0",
        },
        "& h4": {
            margin: "1rem 0"
        },
        margin: "2rem 0",
        "& h5": {
            margin: "0.7rem 0"
        },
        "& h6": {
            margin: "0.7rem 0"
        },
    },
    table: {
        "& allBorder": {
            border: "1px solid #ddd",
            padding: "0.7rem 0"
        },
    },
    formControl: {
        margin: "1",
        width: "100%"
    },
    background: {
        backgroundColor: theme.palette.background.paper,
        width: "100%",
        padding: "2rem",
        margin: "2rem 0"
    },
    bold: {
        fontWeight: 900,
    },
    comment: {
        width: 500,
    },
    bottomMargin: {
        marginBottom: theme.spacing(2)
    },
    topMargin: {
        marginTop: theme.spacing(2)
    },
    bigTopMargin: {
        marginTop: theme.spacing(4)
    },
    buttonRight: {
        float: "right" as const,
        marginBottom: theme.spacing(2)
    },
    updateFieldSmall: {
        width: 100,
    },
    adornedEnd: {
        padding: "1px 10px"
    },
    button: {
        margin: '10px',
    },
    card: {
        height: 155,        
        marginBottom: theme.spacing(4),
        fload: "left" as const,
        marginRight: theme.spacing(1)
    },
    cardTitle: {
        paddingBottom: theme.spacing(2),
    },
    paymentError: {
        color: "red"
    },
    aCInputRoot: {
        '&&[class*="MuiOutlinedInput-root"] input': {
            padding: 18
        }
    },
    aCOption: {
        backgroundColor: "white"
    },
    aCListbox: {
        backgroundColor: "white"
    }
});
